import {AxiosInstance} from "./axiosInstance";

export class userService {
    getUserConnected = () => AxiosInstance.get('/user/me');
}
